/**
 * Personal site + social profiles linked from {@link https://www.ashtonspina.com/ ashtonspina.com}
 * (same set used for JobCrawls author `sameAs` and the `/authors/ashton-spina` page).
 */
export type AshtonPersonalSocialLink = {
  readonly label: string;
  readonly href: string;
};

/** Visible on the author profile (excludes this site’s `/authors/…` URL). */
export const ASHTON_PERSONAL_SOCIAL_LINKS: readonly AshtonPersonalSocialLink[] = [
  { label: 'Website', href: 'https://www.ashtonspina.com/' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ashtonspina' },
  { label: 'GitHub (spina-a-d)', href: 'https://github.com/spina-a-d' },
  { label: 'GitHub (ashtonspina)', href: 'https://github.com/ashtonspina' },
  { label: 'Instagram', href: 'https://www.instagram.com/ashtonspina' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@ashtonspina' },
  { label: 'Facebook', href: 'https://www.facebook.com/ashton.spina/' },
] as const;

function dedupeStrings(values: string[]): string[] {
  return [...new Set(values.map((s) => s.trim()).filter(Boolean))];
}

/**
 * `Person.sameAs` URLs for Ashton (JobCrawls profile + personal site + socials).
 */
export function buildAshtonSameAsForJsonLd(jobcrawlsBaseUrl: string): string[] {
  const base = jobcrawlsBaseUrl.replace(/\/+$/, '');
  const profileUrl = `${base}/authors/ashton-spina`;
  return dedupeStrings([profileUrl, ...ASHTON_PERSONAL_SOCIAL_LINKS.map((l) => l.href)]);
}
